module.exports = "/_next/static/images/lknalog_2-db7776873df40de69f65752ba269c751.png";